import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import {FieldSuggestionOption} from "../../models/fieldSuggestion";

@Injectable({
    "providedIn": "root"
})
export class FieldSuggestionService {

    constructor (private http: HttpClient) { }

    getOptions (category: string): Observable<Array<FieldSuggestionOption>> {
        const params = new HttpParams().set(
            "category",
            category
        );
        return this.http.get<Array<FieldSuggestionOption>>(
            `${environment.baseApiUrl}/field-suggestions/`,
            {params}
        );
    }
}
